import queryParams from '$store/queryParams'
import type { CommonAPI } from './common'

export const attachDeviceMeta = (injectRequest: CommonAPI['injectRequest']) => {
  injectRequest(req => {
    const { device_id } = queryParams.peek().params

    if (device_id) req.headers.set('x-device-id', device_id)

    return req
  })
}
